import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { api } from '../lib/api';
// [PATCH povabilo-barve v1]
// [PATCH povabilo-ime-fe v1] stranka: »kot stranka pri <podjetja>«
const nastej = (s: string[]) => (s.length <= 1 ? s.join('') : s.slice(0, -1).join(', ') + ' in ' + s[s.length - 1]);

export function PovabiloPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [info, setInfo] = useState<{email: string; servis: string; vloga: string; baze?: string[]} | null>(null);
  const [napaka, setNapaka] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [geslo, setGeslo] = useState('');
  const [geslo2, setGeslo2] = useState('');
  const [posiljam, setPosiljam] = useState(false);

  useEffect(() => {
    api.get(`/povabila/${token}`)
      .then((r: any) => setInfo(r.data))
      .catch(() => setNapaka('Povabilo ne obstaja ali je poteklo.'));
  }, [token]);

  const oddaj = async (e: React.FormEvent) => {
    e.preventDefault();
    if (geslo.length < 8) { toast.error('Geslo mora imeti vsaj 8 znakov'); return; }
    if (geslo !== geslo2) { toast.error('Gesli se ne ujemata'); return; }
    setPosiljam(true);
    try {
      await api.post(`/povabila/${token}/sprejmi`, {
        password: geslo, first_name: firstName, last_name: lastName,
      });
      toast.success('Račun je ustvarjen! Prijavite se z novim geslom.');
      navigate('/prijava');
    } catch (err: any) {
      toast.error(err?.response?.data?.detail || 'Napaka pri aktivaciji računa');
    } finally {
      setPosiljam(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 px-4">
      <div className="w-full max-w-md bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-8">
        <div className="text-center mb-6">
          <span className="text-2xl font-bold text-gray-900 dark:text-white">
            Alfa<span className="text-blue-600">Berg</span>
          </span>
        </div>

        {napaka && (
          <p className="text-center text-red-600 dark:text-red-400">{napaka}</p>
        )}

        {!napaka && !info && (
          <p className="text-center text-gray-500 dark:text-gray-400">Nalagam povabilo ...</p>
        )}

        {info && (
          <>
            <p className="text-center text-gray-600 dark:text-gray-300 mb-6">
              {info.baze && info.baze.length > 0
                ? <>Povabljeni ste kot <b>{info.vloga}</b> pri <b>{nastej(info.baze)}</b>.</>
                : <>Povabljeni ste v <b>{info.servis}</b> kot <b>{info.vloga}</b>.</>}<br />
              <span className="text-sm text-gray-400">{info.email}</span>
            </p>
            <form onSubmit={oddaj} className="space-y-4">
              <div className="grid grid-cols-2 gap-3">
                <input value={firstName} onChange={(e) => setFirstName(e.target.value)}
                  placeholder="Ime"
                  className="w-full px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white" />
                <input value={lastName} onChange={(e) => setLastName(e.target.value)}
                  placeholder="Priimek"
                  className="w-full px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white" />
              </div>
              <input type="password" value={geslo} onChange={(e) => setGeslo(e.target.value)}
                placeholder="Geslo (vsaj 8 znakov)" required
                className="w-full px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white" />
              <input type="password" value={geslo2} onChange={(e) => setGeslo2(e.target.value)}
                placeholder="Ponovi geslo" required
                className="w-full px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white" />
              <button type="submit" disabled={posiljam}
                className="w-full py-2.5 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-semibold disabled:opacity-50">
                {posiljam ? 'Ustvarjam račun ...' : 'Aktiviraj račun'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
